//import Vue from 'vue'
import axios from "./http-service";
import store from '../store/index';

const memberLogin = (openId) => {
  axios.Post(axios.Url + "/api/memberLogin/" + openId, null).then((res) => {
    let data = res.data;
    if (data.code == 0) {
      // localStorage.setItem("token", data.token);
      store.commit("token",data.token)
    }
  });
};

function getCode() {
  let code = "";
  var local = window.location.href; // 获取页面url
  var appid = "wx0a4460b68c268894"; //公众号appid

  code = getUrlCode().code; // 截取code
  if (code == null || code === "" || code == undefined) {
    // 如果没有code，则去请求
    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
  } else {
    // 有code获取openid;
    //  console.log("获取openid");
    axios
      .Get(axios.wxUrl + "/getWxUserInfo?code=" + code, null)
      .then(async (data) => {
        if (data.code == 0) {
          let openId = data.openid;
          if (openId) {
            await memberLogin(openId);
          }
          localStorage.setItem("userInfo", JSON.stringify(data));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // const data={openid:"owbfUwcq1F56zeFr8bOGVWtGRWXM",nickname:"诚信为本",headimgurl:''}
    // localStorage.setItem('userInfo', JSON.stringify(data));
  }
}

function getUrlCode() {
  // 截取url中的code方法
  var url = location.search;
  var theRequest = new Object();
  if (url.indexOf("?") != -1) {
    var str = url.substr(1);
    var strs = str.split("&");
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
    }
  }
  return theRequest;
}

const getOpenId = async () => {
  let WXInfo = JSON.parse(localStorage.getItem("userInfo"));
  let ua = navigator.userAgent.toLowerCase();
  let isWeixin = ua.indexOf("micromessenger") !== -1; // 是否 在微信浏览器内
  if (!isWeixin) {
    document.head.innerHTML =
      '<title>抱歉，出错了</title><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1, user-scalable=0"><link rel="stylesheet" type="text/css" href="https://res.wx.qq.com/open/libs/weui/0.4.1/weui.css">';
    document.body.innerHTML =
      '<div class="weui_msg"><div class="weui_icon_area"><i class="weui_icon_info weui_icon_msg"></i></div><div class="weui_text_area"><h4 class="weui_msg_title">请在微信客户端打开链接</h4></div></div>';
  }
  if (WXInfo == null) {
    await getCode();
  } else {
    let openId = WXInfo.openid;
    if (openId) {
      await memberLogin(openId);
    }
  }

  //  let data = {
  // 	headimgurl: "http://thirdwx.qlogo.cn/mmopen/vi_32/yc9qtaianSUiboQ3fic2swJdYoydot3vTqibcgqIK35Tww9U9nYZNSabTlKhXeUvvTWZPwLGEZticd5hggYLFHssCZQ/132",
  // 	nickname: "晓水木",
  // 	openid: "owbfUwfHzNlMeSYzSicIL8Ax8Dic"
  // }
  // localStorage.setItem('userInfo', JSON.stringify(data));
};

getOpenId();
export default {
  getOpenId,
};
